export default {"src":"https://fishbrain.com/_next/static/media/kentucky.19078e3c.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};